export default "__VITE_ASSET__B$Zm5q6k__"